// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mail-support-popup {
    top: 0;
    left: 0;
    margin: 0;
    padding: 0;
    width: 100%;
    z-index: 11;
    height: 100%;
    display: flex;
    position: fixed;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.3);
}

.pop-up-header {
    height: 50px;
    color: white;
    display: flex;
    font-size: 16px;
    padding: 2px 19px;
    align-items: center;
    background-color: #1976D2;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    justify-content: space-between;
}

.mail-support {
    width: 50%;
    height: 80%;
    overflow: hidden;
    border-radius: 10px;
    background-color: #FFFFFF;
}

.mail-support-body {
    width: 60%;
    overflow-y: auto;
    padding: 0 20% 10%;
    height: -webkit-fill-available;
}

.can-help {
    height: 80px;
    margin: 10px 0 20px 0;
}

.can-help textarea {
    height: 100%;
    resize: none;
    border-radius: 5px;
    width: -webkit-fill-available;
    font-family: Nunito Sans, Sans-serif, serif;
}

.phone-number {
    display: flex;
    align-items: baseline;
}

.note {
    display: flex;
    border-radius: 5px;
    background-color: #F5F5F5;
}

.note span {
    margin: 15px;
    font-weight: bold;
}

.submit-btn {
    display: flex;
    justify-content: center;
}

.country-code {
    width: 30%;
    height: 60%;
    border-radius: 10px;
    background-color: #FFFFFF;
}

.search {
    display: flex;
    justify-content: center;
}

.search .full-width {
    width: 90%;
}

.codes {
    overflow-y: scroll;
    height: 75%;
}

.code-row {
    width: 90%;
    margin: auto;
    cursor: pointer;
}

.code-row p {
    font-size: 18px;
    padding-bottom: 10px;
    border-bottom: 1px solid #BDBDBD;
}

.code-row p span {
    margin: 0 10px;
}

@media screen and (max-width: 600px) {
    .mail-support {
        width: 100%;
        height: 100%;
        border-radius: 0;
    }

    .pop-up-header {
        border-radius: 0;
    }

    .pop-up-header span {
        margin: 0 20px;
    }

    .mail-support-body {
        width: 90%;
    }

    .can-help {
        height: 150px;
        margin: 15px 0;
    }

    .can-help textarea {
        font-size: 22px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/dashboard/css/mail-support-popup.css"],"names":[],"mappings":"AAAA;IACI,MAAM;IACN,OAAO;IACP,SAAS;IACT,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".mail-support-popup {\n    top: 0;\n    left: 0;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    z-index: 11;\n    height: 100%;\n    display: flex;\n    position: fixed;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(0, 0, 0, 0.3);\n}\n\n.pop-up-header {\n    height: 50px;\n    color: white;\n    display: flex;\n    font-size: 16px;\n    padding: 2px 19px;\n    align-items: center;\n    background-color: #1976D2;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    justify-content: space-between;\n}\n\n.mail-support {\n    width: 50%;\n    height: 80%;\n    overflow: hidden;\n    border-radius: 10px;\n    background-color: #FFFFFF;\n}\n\n.mail-support-body {\n    width: 60%;\n    overflow-y: auto;\n    padding: 0 20% 10%;\n    height: -webkit-fill-available;\n}\n\n.can-help {\n    height: 80px;\n    margin: 10px 0 20px 0;\n}\n\n.can-help textarea {\n    height: 100%;\n    resize: none;\n    border-radius: 5px;\n    width: -webkit-fill-available;\n    font-family: Nunito Sans, Sans-serif, serif;\n}\n\n.phone-number {\n    display: flex;\n    align-items: baseline;\n}\n\n.note {\n    display: flex;\n    border-radius: 5px;\n    background-color: #F5F5F5;\n}\n\n.note span {\n    margin: 15px;\n    font-weight: bold;\n}\n\n.submit-btn {\n    display: flex;\n    justify-content: center;\n}\n\n.country-code {\n    width: 30%;\n    height: 60%;\n    border-radius: 10px;\n    background-color: #FFFFFF;\n}\n\n.search {\n    display: flex;\n    justify-content: center;\n}\n\n.search .full-width {\n    width: 90%;\n}\n\n.codes {\n    overflow-y: scroll;\n    height: 75%;\n}\n\n.code-row {\n    width: 90%;\n    margin: auto;\n    cursor: pointer;\n}\n\n.code-row p {\n    font-size: 18px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #BDBDBD;\n}\n\n.code-row p span {\n    margin: 0 10px;\n}\n\n@media screen and (max-width: 600px) {\n    .mail-support {\n        width: 100%;\n        height: 100%;\n        border-radius: 0;\n    }\n\n    .pop-up-header {\n        border-radius: 0;\n    }\n\n    .pop-up-header span {\n        margin: 0 20px;\n    }\n\n    .mail-support-body {\n        width: 90%;\n    }\n\n    .can-help {\n        height: 150px;\n        margin: 15px 0;\n    }\n\n    .can-help textarea {\n        font-size: 22px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
